import {
  NgModule
} from '@angular/core';
import {
  AccountsComponent
} from './accounts.component';
import {
  ButtonsModule
} from '@progress/kendo-angular-buttons';
import {
  GridModule
} from '@progress/kendo-angular-grid';
import {
  DateInputsModule
} from '@progress/kendo-angular-dateinputs';
import {
  DropDownsModule
} from '@progress/kendo-angular-dropdowns';
import {
  InputsModule
} from '@progress/kendo-angular-inputs';
import {
  SharedCommonModule
} from '../shared/common';
import {
  AccountsService
} from './accounts.service';
import {
  LoadingIndicatorModule
} from '../shared/layout/components/loading-indicator';
import {BreadcrumbModule} from '../shared/layout/components/breadcrumb';
import {ConfirmDialogComponent} from '../shared/layout/components/confirm-dialog/confirm-dialog.component';
import {UserDialogComponent} from './detail/components/users/user-dialog.component';
import {AccountDialogComponent} from './detail/components/account-dialog/account-dialog.component';
import {MatExpansionModule} from '@angular/material/expansion';

@NgModule({
  declarations: [
    AccountsComponent
  ],
  imports: [
    ButtonsModule,
    GridModule,
    DateInputsModule,
    DropDownsModule,
    InputsModule,
    LoadingIndicatorModule,
    BreadcrumbModule,
    MatExpansionModule,
    SharedCommonModule
  ],
  providers: [
    AccountsService
  ],
  entryComponents: [
    ConfirmDialogComponent,
    AccountDialogComponent
  ],
})
export class AccountsModule {
}
